import { getSiteMetadata } from "./config";
import { SiteMetadata } from "./types";

export const useSiteMetadata = (): SiteMetadata => {
  return getSiteMetadata();
};
